export enum DiagnosticStatus {
  InProgress = 'En cours de rédaction',
  ValidationCLI = 'Signé par participant',
  Signed = 'En cours de validation',
  Validated = 'Validé',
}

export const labelsByDiagnosticStatus: Map<DiagnosticStatus, string> = new Map<DiagnosticStatus, string>(
  Object.keys(DiagnosticStatus).map((x: string) => [x, DiagnosticStatus[x]] as [DiagnosticStatus, string]),
);
